var _defs, _circle, _circle2, _g, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location_circle",
    "data-name": "location circle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.279,
    height: 70.279,
    viewBox: "0 0 70.279 70.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Oval_3",
    x: 14.463,
    y: 16.463,
    width: 41.353,
    height: 41.353,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#003f85"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3-2",
    "data-name": "Oval 3",
    cx: 35.14,
    cy: 35.14,
    r: 35.14,
    fill: "#4877ce",
    opacity: 0.198
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3-3",
    "data-name": "Oval 3",
    cx: 23.426,
    cy: 23.426,
    r: 23.426,
    transform: "translate(11.713 11.713)",
    fill: "#4877ce",
    opacity: 0.201
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Oval_3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3-4",
    "data-name": "Oval 3",
    cx: 8.676,
    cy: 8.676,
    r: 8.676,
    transform: "translate(26.46 26.46)",
    fill: "#fff"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3-5",
    "data-name": "Oval 3",
    cx: 6.074,
    cy: 6.074,
    r: 6.074,
    transform: "translate(29.066 29.115)",
    fill: "#4877ce"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCircle);
export default __webpack_public_path__ + "static/media/location-circle.a7e938051e074af20520487a54e26b48.svg";
export { ForwardRef as ReactComponent };